import {BBModel} from "../bb_model";

const bulkPurchase = {
    query(company) {
        return new Promise((resolve, reject) => {
            if (!company.$has('bulk_purchases')) {
                reject('No bulk purchases found');
            } else {
                company.$get('bulk_purchases').then(resource =>
                        resource.$get('bulk_purchases').then(bulk_purchases => resolve(
                            Array.from(bulk_purchases).map(i => new BBModel.BulkPurchase(i)))
                        )

                    , (err) => {
                        return reject(err);
                    }
                );
            }
        });
    }
};

export {
    bulkPurchase
}